class TransactionsFilterBlock extends waffle.base.BaseComponent {
  getBusinessFilter() {
    if (this.props.include_business) {
      return <waffle.filters.BusinessApiFilter />;
    }

    return <span />;
  }

  getStaffFilter() {
    if (this.props.staff_filter_api) {
      return (
        <waffle.filters.ApiFilter
          api={this.props.staff_filter_api}
          defaultPath="users"
          placeholder="Filter users..."
          additionalParameters="excludeIntegrationStaff=false"
          filterKey="userUUID"
          filterIcon="icon-staff"
        />
      );
    }

    return <span />;
  }

  render() {
    return (
      <waffle.blocks.FilterBlock>
        <waffle.filters.PaymentMethodFilter />
        <waffle.filters.PaymentTypeFilter />
        <waffle.filters.TransactionStateFilter defaults={[]} />
        { this.getBusinessFilter() }
        { this.getStaffFilter() }
        <waffle.filters.PhoneTypeFilter />
        <waffle.filters.ReaderModelFilter showLeft filterKey="readerType" />
      </waffle.blocks.FilterBlock>
    );
  }
}

class BusinessesFilterBlock extends waffle.base.BaseComponent {
  render() {
    return (
      <waffle.blocks.FilterBlock>
        <waffle.filters.BusinessLifeCycleStateFilter />
        <waffle.filters.BusinessCityFilter />
        <waffle.filters.PropertyFilter
          filterKey="businessCategory"
          emptySelectedString="All Business Categories"
          api="/api/api/common/v1/properties/businessCategories"
        />
        <waffle.filters.ReaderModelFilter />
      </waffle.blocks.FilterBlock>
    );
  }
}

class OutboundPayoutFilterBlock extends waffle.base.BaseComponent {
  render() {
    return (
      <waffle.blocks.FilterBlock>
        <waffle.filters.ProcessingBankFilter defaults={this.props.defaults} hidden/>
        <waffle.filters.PayoutStateFilter />
      </waffle.blocks.FilterBlock>
    );
  }
}

class BankAccountUpdateRequestStateFilter extends waffle.filters.BaseFilter {
  loadAvailableOptions() {
    return {
      "executed":{
        "title": "Executed",
        "selected": false
      },
      "manually_executed":{
        "title": "Manually Executed",
        "selected": false
      },
      "change_required":{
        "title": "Change Required",
        "selected": false
      },
      "information_required":{
        "title": "Information Required",
        "selected": false
      },
      "approved":{
        "title": "Approved",
        "selected": false
      },
      "declined":{
        "title": "Declined",
        "selected": false
      }
    };
  }
}

BankAccountUpdateRequestStateFilter.defaultProps = {
  emptySelectedString: "All Requests",
  filterKey: "updateState"
};

class UserUpdateRequestStateFilter extends waffle.filters.BaseFilter {
  loadAvailableOptions() {
    return {
      "confirmation_required":{
        "title": "Confirmation Required",
        "selected": false
      },
      "cancelled":{
        "title": "Cancelled",
        "selected": false
      },
      "approved":{
        "title": "Approved",
        "selected": false
      }
    };
  }
}


UserUpdateRequestStateFilter.defaultProps = {
  emptySelectedString: "All Requests",
  filterKey: "updateState"
};

class PromoCodeStateFilter extends waffle.filters.BaseFilter {
  loadAvailableOptions() {
    return {
      upcoming: {
        title: "Upcoming",
        selected: false
      },
      active: {
        title: "Active",
        selected: false
      },
      ended: {
        title: "Ended",
        selected: false
      }
    };
  }
}

PromoCodeStateFilter.defaultProps = {
  emptySelectedString: "All",
  filterKey: "state"
};


class BankAccountUpdateRequestsFilterBlock extends waffle.base.BaseComponent {
  render() {
    return (<waffle.blocks.FilterBlock>
      <BankAccountUpdateRequestStateFilter />
      <waffle.filters.BusinessApiFilter />
    </waffle.blocks.FilterBlock>);
  }
}

class UserUpdateRequestsFilterBlock extends waffle.base.BaseComponent {
  render() {
    return (<waffle.blocks.FilterBlock>
      <UserUpdateRequestStateFilter />
    </waffle.blocks.FilterBlock>);
  }
}

class TransactionMetricsFilterBlock extends waffle.base.BaseComponent {
  render() {
    return (
      <waffle.blocks.FilterBlock>
        <waffle.filters.BusinessApiFilter />
        <waffle.filters.PhoneTypeFilter />
        <waffle.filters.ReaderModelFilter filterKey="readerType" />
        <waffle.filters.IntegrationFilter showLeft />
        <waffle.filters.CardTypeFilter showLeft />
        <waffle.filters.CardSchemeFilter showLeft />
      </waffle.blocks.FilterBlock>
    );
  }
}

class PayoutDeductionsFilterBlock extends waffle.base.BaseComponent {
  render() {
    return (
      <waffle.blocks.FilterBlock>
        <waffle.filters.ClientBusinessFilter />
        <waffle.filters.ProviderBusinessFilter />
        <waffle.filters.PayoutDeductionStateFilter />
        <waffle.filters.PayoutDeductionTypeFilter />
        <waffle.filters.PayoutDeductionCategoryFilter />
      </waffle.blocks.FilterBlock>
    );
  }
}

class TransactionalDeductionsFilterBlock extends waffle.base.BaseComponent {
  render() {
    return (
      <waffle.blocks.FilterBlock>
        <waffle.filters.MerchantBusinessFilter />
      </waffle.blocks.FilterBlock>
    );
  }
}

class PromoCodeFilterBlock extends waffle.base.BaseComponent {
  render() {
    return (
      <waffle.blocks.FilterBlock>
        <PromoCodeStateFilter />
      </waffle.blocks.FilterBlock>
    );
  }
}

class CapitalOffersFilterBlock extends waffle.base.BaseComponent {
  render() {
    return (
      <waffle.blocks.FilterBlock>
        <waffle.filters.BusinessApiFilter />
        <waffle.filters.ProviderFilter />
      </waffle.blocks.FilterBlock>
    );
  }
}

class CapitalOffersWithStateFilterBlock extends waffle.base.BaseComponent {
  render() {
    return (
      <waffle.blocks.FilterBlock>
        <waffle.filters.BusinessApiFilter />
        <waffle.filters.ProviderFilter />
        <waffle.filters.CapitalOfferStateFilter />
      </waffle.blocks.FilterBlock>
    );
  }
}

class AsyncActionTypeFilter extends waffle.filters.BaseFilter {
  loadAvailableOptions() {
    return {
      "address": {
        "title": "Address",
        "selected": false
      },
      "business": {
        "title": "Business",
        "selected": false
      },
      "businessRisk": {
        "title": "Business Risk",
        "selected": false
      },
      "capitalOffer": {
        "title": "Capital Offer",
        "selected": false
      },
      "capitalPrelimOffer": {
        "title": "Capital Prelim Offer",
        "selected": false
      },
      "ficaVerification": {
        "title": "FICA Verification",
        "selected": false
      },
      "order": {
        "title": "Order",
        "selected": false
      },
      "orderPayment": {
        "title": "Order Payment",
        "selected": false
      },
      "payoutDeductionPlan": {
        "title": "Payout Deduction Plan",
        "selected": false
      },
      "reader": {
        "title": "Reader",
        "selected": false
      },
      "remediation": {
        "title": "Remediation",
        "selected": false
      },
      "signup": {
        "title": "Signup",
        "selected": false
      },
      "updateRequest": {
        "title": "Update Request",
        "selected": false
      },
      "user": {
        "title": "User",
        "selected": false
      }
    }
  }
}

AsyncActionTypeFilter.defaultProps = {
  "emptySelectedString": "All Types",
  "filterKey": "requestType"
};

class AsyncActionResultFilter extends waffle.filters.BaseFilter {
  loadAvailableOptions() {
    return {
      "failed": {
        "title": "Failed",
        "selected": false
      },
      "invalidated": {
        "title": "Invalidated",
        "selected": false
      },
      "pending": {
        "title": "Pending",
        "selected": false
      },
      "processing": {
        "title": "Processing",
        "selected": false
      },
      "rescheduled": {
        "title": "Rescheduled",
        "selected": false
      },
      "successful": {
        "title": "Successful",
        "selected": false
      }
    }
  }
}

AsyncActionResultFilter.defaultProps = {
  "emptySelectedString": "All States",
  "filterKey": "resultType"
};

class SalesforceAsyncActionsFilterBlock extends waffle.base.BaseComponent {
  render() {
    return (
        <waffle.blocks.FilterBlock>
          <AsyncActionTypeFilter />
          <AsyncActionResultFilter />
        </waffle.blocks.FilterBlock>
    );
  }
}

class ByBusinessFilterBlock extends waffle.base.BaseComponent {
  render() {
    return (
      <waffle.blocks.FilterBlock>
        <waffle.filters.BusinessApiFilter {...this.props} />
      </waffle.blocks.FilterBlock>
    );
  }
}

class DisputesFilterBlock extends waffle.base.BaseComponent {
  render() {
    return (
        <waffle.blocks.FilterBlock>
          <waffle.filters.BusinessApiFilter/>
          <waffle.filters.DisputeStateFilter />
          <waffle.filters.HasAdjustmentFilter/>
          <waffle.filters.UserApiFilter
          filterKey="openedByUserUUID"
          with_yoco_role="yoco_staff"
          path="roles.yoco_staff"
          />
        </waffle.blocks.FilterBlock>
    );
  }
}

class BusinessSettlementFilterBlock extends waffle.base.BaseComponent {
  render() {
    return(
        <waffle.blocks.FilterBlock>
          <waffle.filters.PayoutTypeFilter/>
        </waffle.blocks.FilterBlock>
    )
  }
}

module.exports = {
  TransactionsFilterBlock,
  TransactionMetricsFilterBlock,
  BusinessesFilterBlock,
  RequestsFilterBlock: BankAccountUpdateRequestsFilterBlock,
  UserUpdateRequestsFilterBlock: UserUpdateRequestsFilterBlock,
  PayoutDeductionsFilterBlock,
  TransactionalDeductionsFilterBlock,
  PromoCodeFilterBlock,
  OutboundPayoutFilterBlock,
  CapitalOffersFilterBlock,
  CapitalOffersWithStateFilterBlock,
  ByBusinessFilterBlock,
  SalesforceAsyncActionsFilterBlock,
  DisputesFilterBlock,
  BusinessSettlementFilterBlock
};
